import { FC, ReactElement, useEffect } from 'react';

import { LoginForm } from '../../../containers';
import { LoginFormData } from '../../../entities/@forms/LoginForm/LoginForm';
import { GTMEvent } from '../../../entities/GTM/GTM';
import { sendGTMEvent } from '../../../entities/GTM/GTMService';
import { authenticateUser } from '../../../redux/@account/authentication/authenticationActions';
import { useTypedDispatch, useTypedSelector } from '../../../redux/store';

interface ConnectedLoginFormProps {
    heading?: string;
    emailAddress?: string;
    onLoggedIn?: () => void;
    className?: string;
}

export const ConnectedLoginForm: FC<ConnectedLoginFormProps> = ({
    heading,
    emailAddress,
    onLoggedIn,
    className = '',
}): ReactElement => {
    const dispatch = useTypedDispatch();

    const isLoading = useTypedSelector(state => state.authenticationSlice.isLoading);
    const isAuthenticated = useTypedSelector(state => state.authenticationSlice.isAuthenticated);
    const error = useTypedSelector(state => state.authenticationSlice.error);

    const handleSubmit = async (formData: LoginFormData): Promise<void> => {
        await dispatch(authenticateUser(formData));
    };

    useEffect((): void => {
        if (!isAuthenticated) {
            return;
        }

        sendGTMEvent(GTMEvent.login);

        if (onLoggedIn) {
            onLoggedIn();
        }
    }, [isAuthenticated]);

    return (
        <LoginForm
            isLoading={isLoading}
            heading={heading}
            emailAddress={emailAddress}
            error={error}
            onSubmit={handleSubmit}
            className={className}
        />
    );
};
